import { MessageCircle } from "lucide-react";
import { brand } from "../mock";

// Floating WhatsApp button, always visible bottom-right.
export default function WhatsAppFab() {
  return (
    <a
      href={brand.whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scrivici su WhatsApp"
      className="fixed bottom-5 right-5 z-[70] group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
      <span className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5a] text-white font-semibold rounded-full shadow-lg pl-4 pr-5 py-3.5 transition-colors">
        <MessageCircle className="w-5 h-5" />
        <span className="hidden sm:inline">WhatsApp</span>
      </span>
    </a>
  );
}
